// Data Services

import {create} from 'apisauce';

// Default API root is same server, same protocol, same port
let API_ROOT = location.protocol + '//' + location.host + '/api/v1';

if (typeof(jest) === 'undefined') {
  console.debug('API Root: ' + API_ROOT);
}

// access to our main API
export const api = create({baseURL: API_ROOT});

export const fileApi = create({baseURL: API_ROOT, responseType: 'arraybuffer'});

// access to static JSON data files
export const staticData = create({baseURL: '/static/data'});



// WEBPACK FOOTER //
// ./src/services.js